<script>
	import { onMount } from "svelte";
	import Icon from "svelte-awesome";
	import { faCheck } from "@fortawesome/free-solid-svg-icons";
	import { Circle } from "svelte-loading-spinners";
    
	let usernameLocalSession = "";
    let username = "";
    let lockRequest = false;
    export let inputUsername;

	onMount(() => {
		if(localStorage.getItem("username")) {
			usernameLocalSession = localStorage.getItem("username");
			username = usernameLocalSession;
		}
    });

	function handleInputUsername(event) {
		if(event.keyCode == 13) { // keyCode 13 is ENTER
			saveUsername();
		} else {
			if(!lockRequest) {
				lockRequest = true;
				setTimeout(function() {
                    saveUsername();
					lockRequest = false;
				},500);
			}
		}
	}

	function saveUsername() {
		if(username) {
			localStorage.setItem("username", username);
			usernameLocalSession = username;
		}
    }
</script>

<div class="block m-auto flex-wrap">
    <div class="flex justify-center items-center">
        <input class="pl-1.5" bind:this={inputUsername} type="text" name="username" placeholder="Saisir un pseudo" bind:value={username} on:keyup={handleInputUsername}>
        <button class="flex justify-center items-center mx-1.5 p-1 border-none cursor-default {username == usernameLocalSession ? 'text-green-500' : ''}">
            {#if username == usernameLocalSession}
                <Icon data={faCheck} scale="1.1" />
            {:else}
                <Circle size="17" color="black" unit="px" />
            {/if}
        </button>
    </div>
</div>
